import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import api from "../../../services/api";

function paraInputDatetimeLocal(dataISO) {
    if (!dataISO) return "";
    let data = new Date(dataISO);
    let pad = (n) => String(n).padStart(2, "0");
    return `${data.getFullYear()}-${pad(data.getMonth() + 1)}-${pad(data.getDate())}T${pad(data.getHours())}:${pad(data.getMinutes())}`;
}

export default class Prazo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dataLimite: "",
            mensagem: "",
            usuariosLiberados: [],
            carregando: true,
            enviando: false,
            mensagemStatus: "",
            sucesso: false
        };
    }

    componentDidMount() {
        this.carregarPrazo();
    }

    carregarPrazo = async () => {
        this.setState({ carregando: true });
        try {
            let resposta = await api.get("/admin/prazo");
            let prazo = resposta.data.prazo || {};
            this.setState({
                dataLimite: paraInputDatetimeLocal(prazo.dataLimite),
                mensagem: prazo.mensagem || "",
                usuariosLiberados: resposta.data.usuariosLiberados || [],
                carregando: false
            });
        } catch (erro) {
            this.setState({ carregando: false, mensagemStatus: "Não foi possível carregar a configuração de prazo.", sucesso: false });
        }
    };

    onChangeDataLimite = (evento) => {
        this.setState({ dataLimite: evento.target.value });
    };

    onChangeMensagem = (evento) => {
        this.setState({ mensagem: evento.target.value });
    };

    handleSubmit = async (evento) => {
        evento.preventDefault();
        this.setState({ enviando: true, mensagemStatus: "" });

        try {
            await api.put("/admin/prazo", {
                dataLimite: this.state.dataLimite ? new Date(this.state.dataLimite).toISOString() : null,
                mensagem: this.state.mensagem
            });
            this.setState({ enviando: false, sucesso: true, mensagemStatus: "Configuração salva com sucesso." });
        } catch (erro) {
            this.setState({ enviando: false, sucesso: false, mensagemStatus: "Não foi possível salvar a configuração." });
        }
    };

    render() {
        if (this.state.carregando) return <div className="content"><p>Carregando...</p></div>;

        return (
            <Fragment>
                <div className="content">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="card card-user">
                                <div className="card-header">
                                    <h4 className="card-title">Prazo de edição</h4>
                                </div>
                                <div className="card-body">
                                    <p>
                                        Usuários com a função <strong>admin</strong> sempre podem editar metas, independente do prazo.
                                        Para os demais, a edição fica liberada até a data abaixo — depois disso, só leitura.
                                    </p>

                                    <form onSubmit={this.handleSubmit}>
                                        <div className="form-group">
                                            <label>Data/hora limite</label>
                                            <input
                                                type="datetime-local"
                                                className="form-control"
                                                value={this.state.dataLimite}
                                                onChange={this.onChangeDataLimite}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Mensagem exibida após o prazo</label>
                                            <textarea
                                                className="form-control"
                                                value={this.state.mensagem}
                                                onChange={this.onChangeMensagem}
                                            />
                                        </div>

                                        {this.state.mensagemStatus && (
                                            <div className="form-group">
                                                <div className={this.state.sucesso ? "alert alert-success" : "alert alert-danger"} role="alert">
                                                    {this.state.mensagemStatus}
                                                </div>
                                            </div>
                                        )}

                                        <button className="btn btn-primary" disabled={this.state.enviando}>Salvar</button>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="card card-user">
                                <div className="card-header">
                                    <h4 className="card-title">Usuários liberados individualmente</h4>
                                </div>
                                <div className="card-body">
                                    <p>Continuam podendo editar mesmo depois do prazo acima, independente da role.</p>
                                    {this.state.usuariosLiberados.length === 0 ? (
                                        <p className="text-muted">Nenhum usuário liberado individualmente no momento.</p>
                                    ) : (
                                        <table className="table table-striped table-hover table-bordered table-sm">
                                            <thead>
                                                <tr>
                                                    <th>Nome</th>
                                                    <th>Usuário</th>
                                                    <th>Unidade</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.usuariosLiberados.map((usuario) => (
                                                    <tr key={usuario._id}>
                                                        <td>{usuario.nome}</td>
                                                        <td>{usuario.username}</td>
                                                        <td>{usuario.unidade}</td>
                                                        <td><Link to={`/admin/usuarios/${usuario._id}`}>Editar</Link></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
